export default "__VITE_ASSET__BabgFYU5__"